import NewsComp from "../../components/news/NewsComp"
import { useTranslation } from "react-i18next"

export default function News004() {

    const { t } = useTranslation()

    const newsText = [
        t('news:news.4.p1'),
        t('news:news.4.p2'),
        t('news:news.4.p3'),
        t('news:news.4.p4')
    ]

    const newsImage = [
        "news004-img1.jpg"
    ]
    return (
        <div>
            <NewsComp
                newsImage={newsImage}
                newsText={newsText}
                date="2021-03-30"
                headline={t('news:headline.4')}
            />
        </div>
    )
}